import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7c2bd57e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7c2bd57e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2bd57e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c2bd57e')) {
      api.createRecord('7c2bd57e', component.options)
    } else {
      api.reload('7c2bd57e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7c2bd57e&scoped=true", function () {
      api.rerender('7c2bd57e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/welfareCard/package/index.vue"
export default component.exports